// button.js
import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VideocamIcon from '@mui/icons-material/Videocam';
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";

// styled()로 커스텀 디자인 적용
const IconCustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#242C5C',
  color: '#fff',
  height: '80px',
  borderRadius: '20px',
  padding: '8px 60px',
  textTransform: 'none',
  fontSize:'var(--ft-30)',
  fontWeight: 'var(--ft-SemiBold)',
  border:'4px solid var(--pr-60)',
  '&:hover': {
    backgroundColor: 'var(--pr-60)',
  },
  '& .MuiButton-startIcon': {
    marginRight: '10px',
    '& > *:nth-of-type(1)': {
      fontSize: '38px',
    },
  },
}));

/* 뒤로가기 아이콘 포함 버튼*/
export const IconLabelBackButtons = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); 
  };

  return (
    <IconCustomButton
      variant="contained"
      startIcon={<ArrowBackIcon />}
      onClick={handleBack}
    >
      뒤로가기
    </IconCustomButton>
  );
};
/* ==================== */
/* cctv 조회 아이콘 포함 버튼*/
export const StyledIconCctvBtn = () => {

  return (
    <IconCustomButton 
      variant="contained"
      // startIcon={<VideocamIcon />}
    >
      CCTV
    </IconCustomButton>
  );
};
/* ==================== */

/* 조회하기 버튼 */
const CustomButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#242C5C',
    color: '#fff',
    height: '80px',
    borderRadius: '20px',
    padding: '8px 60px',
    textTransform: 'none',
    fontSize:'var(--ft-30)',
    fontWeight: 'var(--ft-SemiBold)',
    border:'4px solid var(--pr-60)',
    '&:hover': {
      backgroundColor: 'var(--pr-60)',
    },
  }));

export const SrchButtons = ({ onClick }) => (
<CustomButton
    variant="contained"
    onClick={onClick}
>
    조회
</CustomButton>
);

const BusCustomButton = styled(Button)(({ theme, active }) => ({
  backgroundColor: active ? 'var(--pr-60)' : '#242C5C',
  color: '#fff',
  height: '80px',
  borderRadius: '20px',
  padding: '8px 60px',
  textTransform: 'none',
  fontSize: 'var(--ft-30)',
  fontWeight: 'var(--ft-SemiBold)',
  border: '4px solid var(--pr-60)',
  '&:hover': {
    backgroundColor: 'var(--pr-60)',
  },
}));


export const BusCustomButtonGrp = ({ setViewMode }) => {
  const [activeMode, setActiveMode] = React.useState('in');

  const handleClick = (mode) => {
    setViewMode(mode);
    setActiveMode(mode);
  };

  return (
    <Stack spacing={2} direction="row">
      <BusCustomButton
        variant="contained"
        active={activeMode === 'in' ? 1 : 0}
        onClick={() => handleClick('in')}
      >
        승차
      </BusCustomButton>
      <BusCustomButton
        variant="contained"
        active={activeMode === 'out' ? 1 : 0}
        onClick={() => handleClick('out')}
      >
        하차
      </BusCustomButton>
    </Stack>
  );
};